const features = [
  {
    title: '暑期档必看十大电影',
    desc: '这个夏天最值得期待的院线大片，从动作到动画全收录',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20movie%20marquee%20with%20warm%20golden%20spotlights%20against%20dark%20theater%20exterior%2C%20elegant%20film%20poster%20aesthetic%2C%20dramatic%20lighting%20with%20amber%20and%20crimson%20gradients%2C%20grand%20entertainment%20atmosphere%2C%20no%20text%20no%20people&width=1200&height=600&seq=carousel-feat-01&orientation=landscape',
  },
  {
    title: '悬疑片单：烧脑神作精选',
    desc: '从经典到新锐，让你看到最后一秒还在猜结局的高分悬疑',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20maze%20pattern%20with%20dramatic%20shafts%20of%20golden%20light%20breaking%20through%20darkness%2C%20mysterious%20geometric%20shadows%2C%20suspenseful%20noir%20atmosphere%2C%20deep%20contrast%20with%20warm%20highlight%20accents%2C%20puzzling%20labyrinthine%20composition%2C%20cinematic%20depth&width=1200&height=600&seq=carousel-feat-02&orientation=landscape',
  },
  {
    title: '高分纪录片：看见真实世界',
    desc: '自然、人文、科技，每一部都让你重新认识这个世界',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20world%20landscape%20with%20dramatic%20golden%20hour%20light%20illuminating%20mountain%20silhouettes%2C%20layered%20atmospheric%20depth%2C%20warm%20natural%20tones%20against%20dark%20sky%2C%20documentary%20cinematic%20aesthetic%2C%20epic%20scale%20and%20discovery%20mood%2C%20rich%20texture%20details&width=1200&height=600&seq=carousel-feat-03&orientation=landscape',
  },
  {
    title: '宫崎骏动画电影全集',
    desc: '吉卜力工作室经典作品高清合集，治愈你的每一个周末',
    img: 'https://readdy.ai/api/search-image?query=Dreamy%20floating%20islands%20and%20soft%20clouds%20in%20golden%20twilight%20sky%2C%20whimsical%20fantasy%20atmosphere%20with%20warm%20glowing%20light%2C%20gentle%20color%20palette%20of%20amber%20and%20soft%20pastels%2C%20magical%20animated%20film%20aesthetic%2C%20peaceful%20enchanting%20mood%2C%20no%20characters&width=1200&height=600&seq=carousel-feat-04&orientation=landscape',
  },
  {
    title: '漫威宇宙观影指南',
    desc: '从钢铁侠到复仇者联盟，按时间线整理的完整观影顺序',
    img: 'https://readdy.ai/api/search-image?query=Epic%20cosmic%20abstract%20background%20with%20warm%20golden%20energy%20waves%20radiating%20from%20center%2C%20dramatic%20space%20nebula%20in%20amber%20and%20crimson%20tones%2C%20powerful%20cinematic%20atmosphere%2C%20heroic%20scale%20and%20grandeur%2C%20dynamic%20light%20composition%20against%20deep%20darkness&width=1200&height=600&seq=carousel-feat-05&orientation=landscape',
  },
  {
    title: '日剧推荐：治愈系佳作',
    desc: '温暖人心的日剧精选，美食、生活、爱情，治愈你的疲惫',
    img: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20Japanese%20room%20interior%20with%20soft%20golden%20sunlight%20streaming%20through%20paper%20screens%2C%20minimalist%20zen%20atmosphere%2C%20gentle%20shadows%20and%20warm%20wood%20tones%2C%20peaceful%20contemplative%20mood%2C%20cinematic%20still%20life%20composition%2C%20no%20people&width=1200&height=600&seq=carousel-feat-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-8 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-400 bg-secondary-500/10 rounded-full mb-3">
            深度策划
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            焦点专题
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            精心策划的影视专题，发现更多好内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              className="group relative rounded-lg overflow-hidden bg-background-100 border border-background-200/60 hover:border-secondary-500/30 transition-all duration-300"
            >
              <div className="relative aspect-[2/1] overflow-hidden">
                <img
                  src={item.img}
                  alt={`天堂影院专题 - ${item.title}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-background-100/30 to-transparent"></div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-secondary-400 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}